import _extends from "@babel/runtime/helpers/esm/extends";
import React, { useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { buildVersionedClass, buildVersionedClassNames } from '@op/opds.opux-utilities';
import { classNames, useLocale, StatusMessage } from '@op/opds.opux';
import messages from './_messages';
const mergeIds = classNames;
export function CounterWrapper(_ref) {
  let {
    children,
    className,
    size,
    wrapperProps
  } = _ref;
  return /*#__PURE__*/React.createElement("div", _extends({}, wrapperProps, {
    className: buildVersionedClassNames('ds-text-input__counter', className, {
      ["ds-text-input__counter--" + size]: size !== 'default'
    })
  }), children);
}
export function Counter(_ref2) {
  let {
    counter,
    inputRef,
    maxLength,
    size,
    statusMessage,
    valueLength
  } = _ref2;
  const lc = useLocale();
  if (!counter) {
    return null;
  }
  const cn = buildVersionedClassNames('ds-counter', {
    ["ds-counter--" + size]: size !== 'default'
  });
  const message = statusMessage != null ? statusMessage : messages[lc].full;
  if (typeof counter === 'string') {
    return /*#__PURE__*/React.createElement("div", {
      className: cn
    }, counter);
  }
  return /*#__PURE__*/React.createElement("div", {
    className: cn,
    onClick: () => {
      var _inputRef$current;
      return inputRef == null || (_inputRef$current = inputRef.current) == null ? void 0 : _inputRef$current.focus();
    }
  }, maxLength ? valueLength + " / " + maxLength : valueLength, maxLength !== undefined && valueLength !== undefined ? maxLength > 0 && valueLength >= maxLength && /*#__PURE__*/React.createElement(StatusMessage, {
    hidden: true
  }, message) : null);
}
export function UnitInput(_ref3) {
  let {
    className,
    inputClassName,
    inputProps,
    inputRef,
    type,
    unit,
    unitPos,
    unitProps,
    wrapperProps
  } = _ref3;
  const [stateUnitId] = useState(() => "ds-ti-unit-" + uuidv4());
  const unitId = (unitProps == null ? void 0 : unitProps.id) || stateUnitId;
  const wrapClassName = classNames(wrapperProps.className, buildVersionedClass("ds-text-input--unit-" + unitPos), unitPos === 'inside' && className);
  const prevLabels = inputProps['aria-labelledby'];
  return /*#__PURE__*/React.createElement("div", _extends({}, wrapperProps, {
    className: wrapClassName
  }), /*#__PURE__*/React.createElement("input", _extends({}, inputProps, {
    "aria-labelledby": mergeIds(prevLabels, unitId),
    className: classNames(inputClassName, unitPos === 'outside' && className),
    ref: inputRef,
    type: type
  })), /*#__PURE__*/React.createElement("span", _extends({}, unitProps, {
    className: buildVersionedClassNames('ds-text-input__unit', unitProps == null ? void 0 : unitProps.className),
    id: unitId
  }), unit));
}